import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import fr from "./fr.json";
import pt from "./pt.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", flag: "🇬🇧", short: "EN" },
  { code: "fr", label: "Français", flag: "🇫🇷", short: "FR" },
  { code: "pt", label: "Português", flag: "🇵🇹", short: "PT" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      pt: { translation: pt },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "pt"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "aocems_lang",
    },
    returnObjects: true,
  });

// Update <html lang> when language changes
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

// Also set <html lang> on initial load once i18n resolves the restored language.
// Using both `initialized` and an immediate assignment guards against the init
// happening synchronously vs. async.
i18n.on("initialized", () => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = i18n.language || "en";
  }
});
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language || "en";
}

export default i18n;
